import CloseIcon from "@mui/icons-material/Close";
import { IconButton } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import * as CSC from "SC";
import { SignUpLayout } from "./SignUpLayout";

export const SignUpRecipientDone = () => {
  const navigate = useNavigate();

  return (
    <SignUpLayout>
      <div className="bg-white p-4 sm:p-8 rounded-2xl flex flex-col justify-center items-start sm:gap-6 max-w-2xl relative">
        <IconButton
          sx={{ position: "absolute", right: 4, top: 4 }}
          size="small"
          onClick={() => navigate("/")}
        >
          <CloseIcon />
        </IconButton>
        <div className="text-xl sm:text-3xl font-bold mr-4">
          Registration Successful!
        </div>
        <div>Welcome! You have successfully registered as a new recipient.</div>
        <Link to="/">
          <CSC.BlueButton variant="contained" sx={{ width: "100%" }}>
            Log In
          </CSC.BlueButton>
        </Link>
      </div>
    </SignUpLayout>
  );
};
